module.exports = __webpack_public_path__ + "static/firefox-319c6802313fdddaae75bbe61ec3501b.png";